var map = {
	"./Ground1.png": 285,
	"./Ground2.png": 9081,
	"./Ground3.png": 9569,
	"./MapInstruct.png": 6809,
	"./MapInstruct1.png": 3169,
	"./about-company/about-1.png": 3809,
	"./about-company/about-2.png": 2886,
	"./airplane.png": 2127,
	"./article/article.png": 6181,
	"./article/calendar.png": 3402,
	"./article/eye.png": 3280,
	"./back_to_top.png": 1490,
	"./bg-boat.png": 7179,
	"./bg-plane.png": 8323,
	"./bg-train.png": 6668,
	"./bg-trunk.png": 7335,
	"./bg/avia.png": 7444,
	"./bg/ground.png": 7865,
	"./bg/inter.png": 1733,
	"./bg/rail.png": 2213,
	"./block2/block21.png": 2785,
	"./block2/block22.png": 8248,
	"./block2/block23.png": 8631,
	"./block2/block24.png": 4674,
	"./block21.png": 7331,
	"./block5/block51.png": 9147,
	"./block5/block52.png": 1782,
	"./block5/block53.png": 7582,
	"./block5/block54.png": 1478,
	"./block5/block55.png": 60,
	"./block5/block56.png": 5028,
	"./block5/icon1.png": 8605,
	"./block5/icon2.png": 5135,
	"./block5/icon3.png": 7626,
	"./block5/icon4.png": 9895,
	"./block5/icon5.png": 8233,
	"./block5/icon6.png": 6948,
	"./block6Back.png": 817,
	"./block6Back2.png": 9697,
	"./block6Back3.png": 536,
	"./block6BackBot.png": 4446,
	"./boat.png": 9700,
	"./bottomBack.png": 6092,
	"./contacts/map.png": 7027,
	"./footerCar.png": 2365,
	"./header/head-call.png": 483,
	"./langs/en.png": 8764,
	"./langs/kz.png": 1005,
	"./main-car.png": 7245,
	"./main-railway.png": 9283,
	"./main/airplane.png": 7873,
	"./main/boat.png": 9340,
	"./main/train.png": 6091,
	"./main/trunk.png": 9360,
	"./mainBannerNew.png": 1769,
	"./mainIntro.png": 888,
	"./mapKZ.png": 873,
	"./news/item-1.png": 9658,
	"./news/item-2.png": 7442,
	"./news/item-3.png": 4755,
	"./news/item-4.png": 8348,
	"./news/item-5.png": 2628,
	"./news/item-6.png": 4900,
	"./news/item-7.png": 9629,
	"./news/item-8.png": 3377,
	"./news/item-9.png": 6947,
	"./news/Слой 2.png": 2059,
	"./newsBackground.png": 9354,
	"./newsBackground1.png": 5703,
	"./newsBackgroundMobile.png": 6621,
	"./next.png": 3831,
	"./our-services/avia/1.png": 4154,
	"./our-services/avia/2.png": 9732,
	"./our-services/avia/3.png": 5443,
	"./our-services/avia/4.png": 3126,
	"./our-services/avia/block2.png": 864,
	"./our-services/ground/benefits.png": 8135,
	"./our-services/ground/car.png": 865,
	"./our-services/ground/cars.png": 2218,
	"./our-services/ground/main-img.png": 2335,
	"./our-services/ground/main.png": 9612,
	"./our-services/icons/container.png": 8851,
	"./our-services/icons/earth.png": 9938,
	"./our-services/icons/navigator.png": 6853,
	"./our-services/icons/wallet.png": 6107,
	"./our-services/international/block2.png": 4187,
	"./our-services/international/golden-correct-tick-mark-sign-best-quality-assurance-with-golden-five-stars-guarantee-product-iso-service-concept-by-3d-render 1.png": 140,
	"./our-services/international/main.png": 5213,
	"./our-services/international/Ресурс 1 34.png": 6153,
	"./our-services/international/Ресурс 2 11.png": 7679,
	"./our-services/rails.png": 6825,
	"./prev.png": 5983,
	"./slider1.png": 6109,
	"./slider10.png": 2014,
	"./slider11.png": 9146,
	"./slider12.png": 6326,
	"./slider13.png": 1564,
	"./slider2.png": 3238,
	"./slider3.png": 4871,
	"./slider4.png": 895,
	"./slider5.png": 3077,
	"./slider6.png": 4023,
	"./slider7.png": 343,
	"./slider8.png": 9604,
	"./slider9.png": 5818,
	"./sphereConts.png": 6606,
	"./steps.png": 6353,
	"./track0.png": 5784,
	"./track00.png": 4429,
	"./train.png": 3500,
	"./trunk.png": 6183,
	"./types.png": 4562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;